<div class="container-fluid">
    <div class="row justify-content-center">

        <div class="col-sm-12 col-md-8">
            <div class="card my-5 text-center custom-shadow">
                <div class="card-header color-secundario-fondo text-white custom-shadow custom-card-header py-3">
                    <h4>{{titulo}}</h4>
                </div>
    
                <div class="card-body p-0">
                    <ul class="list-group list-group-flush my-4">
                        <li (click)="onClickSetPerfilSesion(p)"
                            class="list-group-item pointer efecto-hover-primario py-3"
                            *ngFor="let p of perfiles; index as i">
                            {{p.gru_id}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>